(function () {
  function mount(container) {
    if (!container || container.dataset.ycjMounted) return;
    container.dataset.ycjMounted = '1';

    var html = window.__ycjAnimatedBannerHTML || '';
    html = html
      .replace(/__YCJ_PIGEON_URL__/g, container.dataset.pigeon || '')
      .replace(/__YCJ_DOG_URL__/g, container.dataset.dog || '')
      .replace(/__YCJ_CAT_URL__/g, container.dataset.cat || '');

    container.innerHTML = html;
  }

  function animatedBannerToggle(banner) {
    var expanded = banner.classList.toggle('ab-expanded');
    banner.querySelectorAll('.ab-pos').forEach(function (el) {
      var x = expanded ? el.dataset.x2 : el.dataset.x1;
      var y = expanded ? el.dataset.y2 : el.dataset.y1;
      if (x !== undefined) el.style.left = x + 'px';
      if (y !== undefined) el.style.top = y + 'px';
    });
  }

  function animatedBannerExpand(banner) {
    if (!banner || banner.classList.contains('ab-expanded')) return;
    animatedBannerToggle(banner);
  }

  window.YcjAnimatedBanner = {
    mount: mount,
    toggle: animatedBannerToggle,
    expand: animatedBannerExpand
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ycj-newsletter-onboarding__anim-wrap[data-dog]').forEach(mount);
  });
})();
